import { render, staticRenderFns } from "./NameItem.vue?vue&type=template&id=0ecdf4b2&scoped=true"
import script from "./NameItem.vue?vue&type=script&lang=js"
export * from "./NameItem.vue?vue&type=script&lang=js"
import style0 from "./NameItem.vue?vue&type=style&index=0&id=0ecdf4b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecdf4b2",
  null
  
)

export default component.exports